import useAnimation from "@/mono/lib/hooks/useAnimation";
import { forwardRef, useImperativeHandle, useMemo, useRef } from "react";

import arrow from "@/assets/arrow_light.png";
import { useTexture } from "@react-three/drei";
import { map } from "@/mono/lib/math";

const SIZE = 0.5;

function NineGLImageOverlay({ z = 0.25, ...props }, ref) {
  const overlay = useRef();
  const tArrow = useTexture(arrow.src);

  const maxScale = useMemo(() => {
    if (props.scale) return 0.35;
  }, [props.scale]);

  const aspect = useMemo(() => {
    if (props.scale) return props.scale.x / props.scale.y;
  }, [props.scale]);

  const onUpdateOverlay = (v) => {
    if (!overlay.current) return;
    overlay.current.scale.set(v * maxScale, v * maxScale * aspect, 1);
    const rotZ = map(v, 0, 1, 0.6, 0);
    overlay.current.rotation.set(0, 0, rotZ);
    overlay.current.material.opacity = v;
  };

  const { animateIn: animateOverlayIn, animateOut: animateOverlayOut } =
    useAnimation({
      inParams: {
        duration: 0.7,
        onUpdate: onUpdateOverlay,
        delay: 0.1,
      },
      outParams: {
        duration: 0.5,
        onUpdate: onUpdateOverlay,
      },
    });

  useImperativeHandle(ref, () => ({
    animateIn: animateOverlayIn,
    animateOut: animateOverlayOut,
  }));

  // TODO: Adjustable size per image

  // const scale = useMemo(() => {
  //   if (props.scale) return props.scale.x * 0.35;
  //   else return 1;
  // }, [props.scale]);

  return (
    <group {...props}>
      <mesh scale={[0, 0, 0]} renderOrder={2} position-z={z} ref={overlay}>
        <planeGeometry args={[SIZE, SIZE]} />
        <meshBasicMaterial transparent={true} map={tArrow} />
      </mesh>
    </group>
  );
}

export default forwardRef(NineGLImageOverlay);
